import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import DeleteButton from '../../../../../common/iconButtons/DeleteButton'
import Loader from '../../../../../common/loader/Loader'
import { Mutation, Query } from '../../../../../react-apollo/Components'
import { i18n } from '../../../../index/index'
import { LinkTagCreationDialog } from './LinkTagCreationDialog'
import css from './LinkTags.css'
import { createLinkTag, deleteLinkTag, fetchLinkTags } from './queries'

interface QueryResponse {
  linkTags: {
    id: string
    name: string
  }[]
}

export function LinkTags() {
  const [creationModalIsOpen, setCreationModalIsOpen] = React.useState(false)

  function onCreateLinkTag(onMutate: any, refetch: any, name: string) {
    onMutate({ variables: { name } })
    setCreationModalIsOpen(false)
    refetch()
      .then(() => {
        console.log('Link tag created')
      })
      .catch((err) => {
        console.log(err)
      })
  }

  function onDeleteLinkTag(onMutate: any, refetch: any, id: string) {
    onMutate({ variables: { id } })
    refetch()
      .then(() => {
        console.log('Link tag removed')
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <div>
      <Typography variant='h5'>{i18n.t('admin.linkTags.title')}</Typography>
      <Paper>
        <Query<QueryResponse, {}> query={fetchLinkTags} fetchPolicy='network-only'>
          {({ loading, error, data, refetch }) => {
            return (
              <Loader {...{ loading, error }}>
                {data.linkTags && data.linkTags.length > 0 ? (
                  <div>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{i18n.t('admin.linkTags.linkTagName')}</TableCell>
                          <TableCell>{i18n.t('buttons.delete')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.linkTags.map((linkTag) => (
                          <TableRow key={linkTag.id}>
                            <TableCell>{linkTag.name}</TableCell>
                            <TableCell>
                              <Mutation
                                mutation={deleteLinkTag}
                                fetchPolicy='network-only'
                                refetchQueries={[fetchLinkTags]}
                              >
                                {(onMutate) => (
                                  <DeleteButton onClick={() => onDeleteLinkTag(onMutate, refetch, linkTag.id)} />
                                )}
                              </Mutation>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                ) : (
                  <div className={css.noResults}>{i18n.t('admin.linkTags.noResults')}</div>
                )}
                <Mutation mutation={createLinkTag} fetchPolicy='network-only' refetchQueries={[fetchLinkTags]}>
                  {(onMutate) => (
                    <LinkTagCreationDialog
                      isOpen={creationModalIsOpen}
                      onClose={() => setCreationModalIsOpen(false)}
                      onSave={(name: string) => onCreateLinkTag(onMutate, refetch, name)}
                    />
                  )}
                </Mutation>
              </Loader>
            )
          }}
        </Query>
      </Paper>
      <div className={css.createNewLinkTagButtonWrapper}>
        <Button variant='contained' color='primary' onClick={() => setCreationModalIsOpen(true)}>
          {i18n.t('admin.linkTags.createLinkTag')}
        </Button>
      </div>
    </div>
  )
}
